export default "__VITE_ASSET__DaghxZ5n__"